import React from "react";

const GREEN = "#35A93E";
const DARK = "#16351D";

const pageStyle = {
  width: "100%",
  maxWidth: "1180px",
  margin: "0 auto 55px",
  background: "rgba(255,255,255,0.97)",
  padding: "65px 70px",
  boxSizing: "border-box",
  borderRadius: "24px",
  border: "1px solid rgba(53,169,62,0.12)",
  boxShadow:
    "0 25px 70px rgba(20,80,35,0.12), 0 8px 25px rgba(0,0,0,0.06)",
  position: "relative",
  overflow: "hidden",
};

const headingStyle = {
  color: DARK,
  fontWeight: "800",
  marginBottom: "18px",
  letterSpacing: "-0.5px",
};

const subHeadingStyle = {
  color: "#26392b",
  fontWeight: "700",
  marginBottom: "12px",
  lineHeight: "1.4",
  fontSize: "18px",
};

const textStyle = {
  color: "#4b5a50",
  lineHeight: "1.75",
  fontSize: "14px",
};

const imageFrame = {
  padding: "12px",
  borderRadius: "24px",
  background: "linear-gradient(145deg, #ffffff, #eaf7ec)",
  boxShadow:
    "15px 18px 40px rgba(24,105,39,0.15), -5px -5px 15px rgba(255,255,255,0.9)",
};

const imageStyle = {
  width: "100%",
  maxHeight: "620px",
  objectFit: "contain",
  display: "block",
  margin: "0 auto",
  borderRadius: "17px",
};

const serviceCardStyle = {
  position: "relative",
  borderRadius: "20px",
  padding: "30px",
  marginBottom: "25px",
  background: "linear-gradient(145deg, #ffffff 0%, #f8fcf8 100%)",
  border: "1px solid rgba(53,169,62,0.12)",
  boxShadow:
    "10px 14px 30px rgba(31,91,42,0.09), -5px -5px 15px rgba(255,255,255,0.9)",
  transition: "all 0.3s ease",
};

const featureListStyle = {
  marginTop: "14px",
  paddingLeft: "25px",
  lineHeight: "1.8",
  color: "#4b5a50",
  fontSize: "14px",
};

function ServiceCard({ number, title, subtitle, children }) {
  return (
    <div
      style={serviceCardStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-7px)";
        e.currentTarget.style.boxShadow =
          "14px 22px 42px rgba(31,91,42,0.15)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow =
          "10px 14px 30px rgba(31,91,42,0.09), -5px -5px 15px rgba(255,255,255,0.9)";
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "18px",
          marginBottom: "15px",
        }}
      >
        <div
          style={{
            minWidth: "48px",
            height: "48px",
            borderRadius: "15px",
            background: "linear-gradient(145deg, #48bb52, #279331)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "800",
            fontSize: "18px",
            boxShadow: "5px 7px 15px rgba(53,169,62,0.28)",
          }}
        >
          {number}
        </div>

        <div>
          <h2
            style={{
              ...headingStyle,
              fontSize: "22px",
              margin: 0,
            }}
          >
            {title}
          </h2>

          {subtitle && (
            <h3
              style={{
                color: GREEN,
                fontSize: "15px",
                margin: "8px 0 0",
                fontWeight: "700",
              }}
            >
              {subtitle}
            </h3>
          )}
        </div>
      </div>

      {children}
    </div>
  );
}

function AIServices() {
  return (
    <div
      style={{
        background:
          "radial-gradient(circle at 10% 0%, rgba(53,169,62,0.14), transparent 30%), radial-gradient(circle at 90% 15%, rgba(53,169,62,0.10), transparent 28%), #f3f8f4",
        padding: "45px 15px",
        minHeight: "100vh",
      }}
    >
      {/* PAGE 1 */}
      <section style={pageStyle}>
        <div
          style={{
            position: "absolute",
            width: "250px",
            height: "250px",
            borderRadius: "50%",
            background: "rgba(53,169,62,0.08)",
            top: "-100px",
            right: "-70px",
          }}
        />

        <div
          style={{
            position: "absolute",
            width: "170px",
            height: "170px",
            borderRadius: "50%",
            background: "rgba(53,169,62,0.06)",
            bottom: "-80px",
            left: "-60px",
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            padding: "85px 20px 100px",
          }}
        >
          <div
            style={{
              display: "inline-block",
              padding: "9px 20px",
              borderRadius: "50px",
              background: "#eaf8ec",
              color: GREEN,
              fontWeight: "700",
              fontSize: "13px",
              marginBottom: "25px",
              boxShadow: "0 7px 18px rgba(53,169,62,0.10)",
            }}
          >
            LIFEONPLUS DIGITAL HEALTHCARE
          </div>

          <h1
            style={{
              background:
                "linear-gradient(90deg, #1d7d28, #35A93E, #61bf69)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: "clamp(26px, 3vw, 36px)",
              fontWeight: "900",
              marginBottom: "25px",
              lineHeight: "1.1",
              letterSpacing: "-1px",
            }}
          >
            LifeOnPlus AI-Enabled Health Services
          </h1>

          <h2
            style={{
              color: "#26392b",
              fontSize: "clamp(17px, 2vw, 22px)",
              fontWeight: "600",
              marginBottom: "35px",
            }}
          >
            Intelligent Digital Health Support — Anytime, Anywhere
          </h2>

          <p
            style={{
              ...textStyle,
              maxWidth: "850px",
              margin: "0 auto",
              fontSize: "16px",
            }}
          >
            LifeOnPlus brings AI-powered health-support tools together in one
            digital healthcare experience, helping members understand health
            information, organize healthy routines, and access useful guidance.
          </p>
        </div>
      </section>

      {/* PAGE 2 */}
      <section style={pageStyle}>
        <div style={imageFrame}>
          <img
            src="/ai-services/image1.jpeg"
            alt="LifeOnPlus AI Health Services"
            style={imageStyle}
          />
        </div>
      </section>

      {/* PAGE 3 */}
      <section style={pageStyle}>
        <div style={imageFrame}>
          <img
            src="/ai-services/image2.jpeg"
            alt="LifeOnPlus Digital Health"
            style={imageStyle}
          />
        </div>
      </section>

      {/* PAGE 4 */}
      <section style={pageStyle}>
        <div style={{ ...imageFrame, marginBottom: "55px" }}>
          <img
            src="/ai-services/image3.jpeg"
            alt="AI Health Services"
            style={{
              ...imageStyle,
              maxHeight: "450px",
            }}
          />
        </div>

        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div
            style={{
              display: "inline-block",
              padding: "8px 18px",
              borderRadius: "50px",
              background: "#eaf8ec",
              color: GREEN,
              fontWeight: "700",
              fontSize: "13px",
              marginBottom: "12px",
            }}
          >
            AI HEALTH SERVICES
          </div>

          <h1
            style={{
              ...headingStyle,
              fontSize: "28px",
              margin: 0,
            }}
          >
            Our AI Health Services
          </h1>
        </div>

        <ServiceCard
          number="1"
          title="AI Symptom Checker"
          subtitle="Understand your symptoms and get helpful guidance."
        >
          <p style={textStyle}>
            Describe your symptoms and receive AI-generated health information
            to help you understand possible areas of concern and decide when
            professional medical advice may be appropriate.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Enter symptoms in simple language</li>
            <li>AI-assisted health information</li>
            <li>Guidance on possible next steps</li>
            <li>Helps prepare for a doctor consultation</li>
          </ul>
        </ServiceCard>
      </section>

      {/* PAGE 5 */}
      <section style={pageStyle}>
        <ServiceCard
          number="2"
          title="AI Diet Planner"
          subtitle="Personalized nutrition guidance for your goals."
        >
          <p style={textStyle}>
            Get AI-assisted meal and nutrition suggestions based on your
            stated goals, preferences and lifestyle information.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Personalized diet suggestions</li>
            <li>Meal-planning assistance</li>
            <li>Healthy food recommendations</li>
            <li>Goal-oriented nutrition guidance</li>
          </ul>
        </ServiceCard>

        <ServiceCard
          number="3"
          title="AI Mental Wellness Check"
          subtitle="A simple way to check in with your wellbeing."
        >
          <p style={textStyle}>
            Use an AI-supported wellness check to reflect on mood and everyday
            wellbeing and receive simple supportive suggestions.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Mood and wellbeing check-ins</li>
            <li>Simple self-reflection</li>
            <li>Lifestyle and wellbeing suggestions</li>
            <li>Encourages healthy daily habits</li>
          </ul>
        </ServiceCard>

        <ServiceCard
          number="4"
          title="AI Medication Advisor"
          subtitle="Understand your medicines and stay organized."
        >
          <p style={textStyle}>
            Get accessible information about medicines, along with medication
            reminders and general safety information.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Medicine information</li>
            <li>Dosage/reminder support</li>
            <li>Medication safety information</li>
            <li>Helps organize medication routines</li>
          </ul>
        </ServiceCard>
      </section>

      {/* PAGE 6 */}
      <section style={pageStyle}>
        <div
          style={{
            background: "linear-gradient(145deg, #effbf1, #ffffff)",
            border: "1px solid rgba(53,169,62,0.15)",
            borderRadius: "18px",
            padding: "22px 25px",
            marginBottom: "30px",
            boxShadow: "0 10px 25px rgba(53,169,62,0.08)",
          }}
        >
          <strong style={{ color: GREEN, fontSize: "14px" }}>
            Important:
          </strong>

          <p style={{ ...textStyle, marginBottom: 0 }}>
            Medication information should complement—not replace—advice from
            a qualified healthcare professional.
          </p>
        </div>

        <ServiceCard
          number="5"
          title="AI Report Summariser"
          subtitle="Turn complex health reports into easier-to-understand information."
        >
          <p style={textStyle}>
            Upload eligible health reports and receive an AI-assisted summary
            designed to help you understand important information before
            discussing it with your healthcare professional.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Upload health reports</li>
            <li>AI-assisted summarization</li>
            <li>Easy-to-understand explanations</li>
            <li>Helps prepare for doctor discussions</li>
          </ul>
        </ServiceCard>

        <ServiceCard
          number="6"
          title="AI First Aid Guide"
          subtitle="Step-by-step guidance for common emergencies."
        >
          <p style={textStyle}>
            Access AI-supported first-aid information for common situations
            while seeking appropriate professional or emergency assistance
            when required.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Step-by-step first-aid information</li>
            <li>Quick access during stressful situations</li>
            <li>Easy-to-follow guidance</li>
            <li>Supports emergency preparedness</li>
          </ul>

          <p
            style={{
              ...textStyle,
              marginTop: "15px",
              fontWeight: "600",
            }}
          >
            For genuine emergencies, users should contact appropriate emergency
            services rather than relying on an AI tool.
          </p>
        </ServiceCard>

        <ServiceCard
          number="7"
          title="AI Sleep Analyser"
          subtitle="Understand your sleep patterns and work toward better sleep."
        >
          <p style={textStyle}>
            Use sleep information to receive AI-assisted observations and
            practical suggestions for healthier sleep habits.
          </p>
        </ServiceCard>
      </section>

      {/* PAGE 7 */}
      <section style={pageStyle}>
        <ServiceCard number="7" title="AI Sleep Analyser">
          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Sleep-pattern analysis</li>
            <li>Sleep habit insights</li>
            <li>Personalized suggestions</li>
            <li>Supports better sleep routines</li>
          </ul>
        </ServiceCard>

        <ServiceCard
          number="8"
          title="AI Calorie Estimator"
          subtitle="Estimate the calories in your meals."
        >
          <p style={textStyle}>
            Use AI-assisted estimation to understand the approximate calorie
            content of foods and meals.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Meal calorie estimation</li>
            <li>Food-based analysis</li>
            <li>Supports nutrition awareness</li>
            <li>Helps with personal health goals</li>
          </ul>

          <p style={textStyle}>
            Calorie estimates are approximate and can vary depending on
            ingredients, portion size and preparation.
          </p>
        </ServiceCard>

        <ServiceCard
          number="9"
          title="Photo & Report Scan"
          subtitle="Scan your health information using your smartphone."
        >
          <p style={textStyle}>
            Upload photographs or supported health reports and receive
            AI-assisted insights and summaries.
          </p>

          <strong style={{ fontSize: "14px" }}>Key features:</strong>

          <ul style={featureListStyle}>
            <li>Photograph/upload reports</li>
            <li>AI-assisted information extraction</li>
            <li>Simplified report insights</li>
            <li>Convenient digital health documentation</li>
          </ul>
        </ServiceCard>
      </section>

      {/* PAGE 8 */}
      <section style={pageStyle}>
        <div style={imageFrame}>
          <img
            src="/ai-services/image4.jpeg"
            alt="LifeOnPlus AI Health Application"
            style={imageStyle}
          />
        </div>
      </section>

      {/* PAGE 9 */}
      <section style={pageStyle}>
        <div style={imageFrame}>
          <img
            src="/ai-services/image5.jpeg"
            alt="LifeOnPlus AI Health Support"
            style={imageStyle}
          />
        </div>
      </section>

      {/* PAGE 10 */}
      <section style={pageStyle}>
        <div style={{ ...imageFrame, marginBottom: "50px" }}>
          <img
            src="/ai-services/image6.jpeg"
            alt="LifeOnPlus Health Report"
            style={{
              ...imageStyle,
              maxHeight: "450px",
            }}
          />
        </div>

        <h1
          style={{
            ...headingStyle,
            fontSize: "28px",
          }}
        >
          One AI-Powered Health Platform
        </h1>

        <h2
          style={{
            color: GREEN,
            fontSize: "22px",
            marginBottom: "18px",
          }}
        >
          From Symptoms to Wellness — LifeOnPlus Helps You Stay Informed
        </h2>

        <p style={textStyle}>
          With LifeOnPlus, members can access a range of AI-enabled tools
          designed around everyday health and wellness:
        </p>

        <div
          style={{
            marginTop: "30px",
            padding: "25px",
            borderRadius: "18px",
            background: "linear-gradient(135deg, #eaf8ec, #ffffff)",
            border: "1px solid rgba(53,169,62,0.15)",
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "800",
            color: GREEN,
            boxShadow: "0 12px 30px rgba(53,169,62,0.10)",
          }}
        >
          Understand → Plan → Track → Learn → Take Action → Connect with Care
        </div>

        <p style={{ ...textStyle, marginTop: "30px" }}>
          The AI services can work alongside the broader LifeOnPlus digital
          healthcare ecosystem, including emergency services, health
          information, doctor consultation and preventive-health services.
        </p>

        <h2
          style={{
            ...headingStyle,
            marginTop: "45px",
            fontSize: "28px",
          }}
        >
          Designed Around You
        </h2>

        <ServiceCard number="🩺" title="Understand">
          <p style={textStyle}>
            Get easier-to-understand health information.
          </p>
        </ServiceCard>
      </section>

      {/* PAGE 11 */}
      <section style={pageStyle}>
        <ServiceCard number="🥗" title="Plan">
          <p style={textStyle}>
            Create healthier nutrition and lifestyle routines.
          </p>
        </ServiceCard>

        <ServiceCard number="💊" title="Organize">
          <p style={textStyle}>
            Keep track of medication-related information and reminders.
          </p>
        </ServiceCard>

        <ServiceCard number="📄" title="Simplify">
          <p style={textStyle}>
            Make health reports easier to understand.
          </p>
        </ServiceCard>

        <ServiceCard number="😴" title="Improve">
          <p style={textStyle}>
            Learn more about sleep and everyday wellbeing.
          </p>
        </ServiceCard>

        <ServiceCard number="🚑" title="Prepare">
          <p style={textStyle}>
            Access first-aid and emergency-preparedness information.
          </p>
        </ServiceCard>

        <ServiceCard number="❤️" title="Connect">
          <p style={textStyle}>
            Use digital information as a starting point for conversations with
            healthcare professionals.
          </p>
        </ServiceCard>

        <div
          style={{
            marginTop: "55px",
            paddingTop: "40px",
            borderTop: "1px solid #dfe9e1",
          }}
        >
          <h1
            style={{
              ...headingStyle,
              fontSize: "28px",
            }}
          >
            AI + Human Healthcare
          </h1>

          <h2
            style={{
              color: GREEN,
              fontSize: "22px",
            }}
          >
            Technology Supports Healthcare. Professionals Remain Essential.
          </h2>

          <p style={textStyle}>
            LifeOnPlus can position these tools as AI-assisted health and
            wellness services, rather than presenting AI output as a medical
            diagnosis or replacement for a doctor.
          </p>

          <p style={textStyle}>
            This distinction is particularly important for services involving
            symptoms, medicines, medical reports or emergency situations.
            Current FDA guidance distinguishes different types of health
            software according to their intended use, and AI-enabled medical
            technologies can have different regulatory requirements depending
            on what they do.
          </p>

          <p style={textStyle}>
            WHO also emphasizes safety, transparency, accountability and
            appropriate governance when AI is used in healthcare.
          </p>
        </div>

        <h2
          style={{
            ...headingStyle,
            marginTop: "45px",
            fontSize: "27px",
          }}
        >
          Website Disclaimer
        </h2>

        <div
          style={{
            background: "linear-gradient(145deg, #fffdf5, #fff8df)",
            border: "1px solid #ead9a8",
            padding: "25px",
            borderRadius: "18px",
            boxShadow: "0 10px 25px rgba(160,130,50,0.08)",
          }}
        >
          <p
            style={{
              ...textStyle,
              marginBottom: 0,
              fontWeight: "600",
            }}
          >
            Important: LifeOnPlus AI-enabled services are intended to provide
            informational, educational and supportive health and wellness
            assistance. AI-generated information is not a medical diagnosis
            and should not replace consultation, diagnosis or treatment by a
            qualified healthcare professional. In an emergency or when
            experiencing serious symptoms, seek appropriate emergency medical
            assistance immediately.
          </p>
        </div>
      </section>

      {/* PAGE 12 */}
      <section style={pageStyle}>
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div
            style={{
              display: "inline-block",
              padding: "8px 18px",
              borderRadius: "50px",
              background: "#eaf8ec",
              color: GREEN,
              fontWeight: "700",
              fontSize: "13px",
              marginBottom: "12px",
            }}
          >
            WEBSITE STRUCTURE
          </div>

          <h1
            style={{
              ...headingStyle,
              fontSize: "29px",
              margin: 0,
            }}
          >
            Suggested Website Layout
          </h1>
        </div>

        <p style={textStyle}>
          I would structure the LifeOnPlus page like this:
        </p>

        <div
          style={{
            marginTop: "30px",
            marginBottom: "35px",
            padding: "35px",
            borderRadius: "22px",
            background: "linear-gradient(135deg, #effbf1, #ffffff)",
            border: "1px solid rgba(53,169,62,0.14)",
            boxShadow: "0 18px 40px rgba(53,169,62,0.10)",
            textAlign: "center",
          }}
        >
          <h2 style={subHeadingStyle}>Hero Banner</h2>

          <h2
            style={{
              color: GREEN,
              fontSize: "22px",
              marginTop: "20px",
              fontWeight: "800",
            }}
          >
            AI-Powered Health. Smarter Support. Better Decisions.
          </h2>
        </div>

        <h2
          style={{
            textAlign: "center",
            color: GREEN,
            fontSize: "25px",
            marginBottom: "30px",
          }}
        >
          ↓
        </h2>

        <h2
          style={{
            ...headingStyle,
            textAlign: "center",
            fontSize: "27px",
          }}
        >
          9 AI Service Cards
        </h2>

        <p
          style={{
            ...textStyle,
            textAlign: "center",
            marginBottom: "35px",
          }}
        >
          Service Website icon/image
        </p>

        <ServiceCard number="🩺" title="AI Symptom Checker">
          <p style={textStyle}>AI + medical cross</p>
        </ServiceCard>

        <ServiceCard number="🥗" title="AI Diet Planner">
          <p style={textStyle}>Healthy food</p>
        </ServiceCard>

        <ServiceCard number="🧠" title="AI Mental Wellness Check">
          <p style={textStyle}>Brain/wellness</p>
        </ServiceCard>

        <ServiceCard number="💊" title="AI Medication Advisor">
          <p style={textStyle}>Medicine/capsule</p>
        </ServiceCard>

        <ServiceCard number="📄" title="AI Report Summariser">
          <p style={textStyle}>Medical report</p>
        </ServiceCard>

        <ServiceCard number="🆘" title="AI First Aid Guide">
          <p style={textStyle}>First-aid kit</p>
        </ServiceCard>

        <ServiceCard number="🌙" title="AI Sleep Analyser">
          <p style={textStyle}>Moon/sleep</p>
        </ServiceCard>

        <ServiceCard number="🔥" title="AI Calorie Estimator">
          <p style={textStyle}>Food/calorie</p>
        </ServiceCard>

        <ServiceCard number="📷" title="Photo & Report Scan">
          <p style={textStyle}>Smartphone + document</p>
        </ServiceCard>
      </section>
    </div>
  );
}

export default AIServices;

